import 'mathlive'
import React from 'react'

interface MathFieldProps {
  latex: string;
  color?: string;
  fontWeight?: string;
}

const MathField = ({ latex, color, fontWeight }: MathFieldProps) => {
  return React.createElement(
    'math-field',
    {
      readonly: true,
      style: {
        backgroundColor: 'transparent',
        color: color || 'black',
        fontWeight: fontWeight || 'normal'
      }
    },
    latex
  )
}

export default MathField;